import { useContext } from 'react';
import { BsBellFill } from 'react-icons/bs';

import userIcon from '../../../assets/images/logo_navbar.png';

import { HeaderServiceManager } from '../../../serviceContextManager/layout/HeaderServiceManager';
import { validatePermissions } from '../../../utils/utils';
import { FormProfileDataModal } from '../FormProfileDataModal';
import { UserMenu } from '../user-menu/User-menu';

interface HeaderProps {
  userMenuRef: React.RefObject<HTMLDivElement>;
  userButtonRef: React.RefObject<HTMLDivElement>;
}

export const Header: React.FC<HeaderProps> = ({
  userMenuRef,
  userButtonRef,
}) => {
  const serviceHeader = useContext(HeaderServiceManager);
  const userName = `${serviceHeader.user?.firstName} ${serviceHeader.user?.lastName}`;

  const renderNavItem = (
    to: string,
    label: string,
    permit: any,
    condition = true,
    parent: string | undefined = undefined
  ) => {
    const hasPermission = permit ? validatePermissions(permit) : condition;

    const isSelected = serviceHeader.menuSelected === parent;

    if (!hasPermission) return null;

    return (
      <div key={to} className="flex h-full w-auto flex-col">
        <div className="flex w-full h-full p-2 justify-center items-center content-center ">
          <div
            // to={to}
            className={`cursor-pointer text-white truncate ${
              isSelected ? 'font-bold' : ''
            }`}
            onClick={() => serviceHeader.onSelectedNavItem(to)}>
            {label}
          </div>
        </div>

        <div
          className={`w-full h-1 bg-official_yellow transition-all duration-300 ${
            isSelected ? 'opacity-100' : 'opacity-0'
          }`}></div>
      </div>
    );
  };

  return (
    <div className="flex z-50  w-full h-16 bg-official_green drop-shadow-md ">
      <div className="flex w-full justify-between items-center h-full">
        {/* Logo */}

        <div className="flex w-1/12 h-full justify-center items-center content-center p-2">
          <img
            src={userIcon}
            alt="Usuario"
            className=" flex w-20 h-8 object-fill"
          />
        </div>

        <div className="flex h-full w-9/12  relative">
          <div className="flex h-full w-full relative flex-row justify-center">
            <div className="flex absolute inset-0 flex-row  overflow-x-auto justify-center gap-2">
              {serviceHeader.navItems.map(item => {
                return renderNavItem(
                  item.to,
                  item.label,
                  item.permit,
                  item.condition,
                  item.parent
                );
              })}
            </div>
          </div>
        </div>

        {/* Right Icons + UserMenu */}

        <div className="flex w-2/12 h-full  justify-start items-center content-center ">
          <div className="flex w-2/5 lg:w-1/5 justify-center">
            {' '}
            <div
              ref={userButtonRef}
              className="flex w-w-full flex-row justify-end items-center">
              <BsBellFill className="text-[25px] opacity-25" />
            </div>
          </div>
          <div className="hidden w-3/5 lg:flex">
            <label className="text-white truncate" htmlFor="">
              {userName}
            </label>
          </div>
          <div className="flex w-4/5 p-1 lg:w-1/5 justify-end content-end items-end">
            <UserMenu
              refCloseProfileCard={userMenuRef}
              setShowPopover={serviceHeader.setShowPopover}
              showPopover={serviceHeader.showPopover}
              serviceHeader={serviceHeader}
            />
          </div>
        </div>
        {/* Profile Modal */}
        <FormProfileDataModal serviceHeader={serviceHeader} />
      </div>
    </div>
  );
};
